import React from "react";
import { CFooter, CLink } from "@coreui/react";
import styles from "../scss/_custom.scss";

const TheFooter = () => {
  return (
    <CFooter fixed={false}>
      <div>
        <CLink
          className={styles.textfooter}
          href="https://www.kelravex.com/"
          target="_blank"
        >
          Copyright (c) by KELRAvex - 2020
        </CLink>
      </div>
      <div className="ml-auto">
        <span className="mr-1"></span>
      </div>
    </CFooter>
  );
};

export default React.memo(TheFooter);
